var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_544_13280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7249 19.9999C29.7249 14.6289 25.3709 10.2749 19.9999 10.2749C14.6289 10.2749 10.2749 14.6289 10.2749 19.9999C10.2749 25.3709 14.6289 29.7249 19.9999 29.7249C25.3709 29.7249 29.7249 25.3709 29.7249 19.9999Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.145 19.9449C21.145 19.3098 20.6301 18.7949 19.995 18.7949C19.3598 18.7949 18.845 19.3098 18.845 19.9449V23.9249C18.845 24.56 19.3598 25.0749 19.995 25.0749C20.6301 25.0749 21.145 24.56 21.145 23.9249V19.9449Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.145 16.0748C21.145 15.4397 20.6301 14.9248 19.995 14.9248C19.3598 14.9248 18.845 15.4397 18.845 16.0748C18.845 16.7099 19.3598 17.2248 19.995 17.2248C20.6301 17.2248 21.145 16.7099 21.145 16.0748Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_13280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.45,
    height: 21.45,
    fill: "white",
    transform: "translate(9.2749 9.2749)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fc1a4c1ff520f621686317dabd03ba5c.svg";
export { ForwardRef as ReactComponent };